import React from 'react';

const BannerBottomBarLayout = ({ children }: { children: React.ReactNode }) => {
  if (!children || !React.Children.toArray(children).some((child) => React.isValidElement(child))) {
    return null;
  }

  return (
    <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 max-w-full w-full z-40">
      <div className="ml-auto flex items-center gap-6">{children}</div>
    </div>
  );
};

export default BannerBottomBarLayout;
